import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';

@Component({
  selector: 'app-terms-and-conditions',
  standalone: true,
  imports: [
    FormsModule,

    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,

    MatCheckbox,
    MatButton
  ],
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TermsAndConditionsComponent {
  consentChecked = false;

  readonly dialogRef = inject(MatDialogRef<TermsAndConditionsComponent>);
  readonly data = inject(MAT_DIALOG_DATA);

  onCancel(): void {
    this.dialogRef.close();
  }
}
